import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  cerProfile: validationNotEmpty("Certificate Profile"),
  cerAlgo: validationNotEmpty("Certificate Algorithm"),
  subjectName: validationNotEmpty("Subject Name"),
  functionMenuName: validationNotEmpty("Certificate File"),
});
  